import { Option } from "core/components/form/select";
import { timeZones } from "./TimeZoneData";

export const timeZoneSelectOptions: Option[] = timeZones.map((timezone) => ({
    label: timezone,
    value: timezone,
}));
